import { FlowStep } from './donor-flow-step';

export interface DonorFlowStepConfig {
  step: FlowStep;
  component: string;
  stepperTitle?: string;
}
